// @flow

import styled from "@emotion/styled";

import { Button } from "../styles";

const Groups = styled(Button)``;

export { Groups };
